import React from 'react'
import { IonContent, IonPage } from '@ionic/react'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { useTranslation } from 'react-i18next'
import PatientNarrativeContent from '../pageContent/PatientNarrative.content'
import { useDispatch } from 'react-redux'
import { saveNarrative } from '../store/narrative.actions'
const PatientNarrative: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const onBackClick = () => {
    history.push(TabConstants.CHART_ROUTE)
  }
  const onSaveClick = () => {
    dispatch(saveNarrative())
  }
  return (
    <IonPage id='patinetNarrativePage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        isBackButton={true}
        nextLabel={t('common.buttons.Save')}
        nextOnClick={onSaveClick}
        title='Narrative'
      />
      <IonContent color='light'>
        <PatientNarrativeContent isPHI />
      </IonContent>
    </IonPage>
  )
}

export default PatientNarrative
